<div class="stats">
    <div class="stats-icon">
        <i class="{{icon}}"></i>
    </div>
    <div class="stats-numbers">{{number}}</div>
    <div class="stats-title">{{title}}</div>
    <div class="stats-subtitle" [innerHTML]="subtitle"></div>
</div>
